<template>
  <div class="a-vs-b--summary">
    <p>
      {{$t('picks')}}:
      <span>{{ numberOfTickets }}</span>
    </p>
    <p>
      {{$t('total_odds')}}:
      <span>{{format(totalOdds)}}</span>
    </p>
    <p>
      {{$t('possible_winning')}}:
      <span>{{ format(possibleWinning)}}</span>
    </p>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'
export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    numberOfTickets: {
      type: Number,
      required: true
    },
    totalOdds: {
      type: Number,
      required: true
    },
    possibleWinning: {
      type: Number,
      required: true
    }
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    }
  }
}
</script>
